import Aim from "@components/Project/Aim";
import Intro from "@components/Project/Intro";
import Projects from "@components/Project/Projects";
import { useParams } from "react-router-dom";
import { ProjectContextProvider } from "../../store/context/projectContext";
import classes from "./Project.module.scss";

const Project = () => {
  const params = useParams<{ projectId: string }>();

  return (
    <ProjectContextProvider projectId={params.projectId}>
      <div className={classes.project}>
        <Intro />
        <Aim />
        <Projects />
      </div>
    </ProjectContextProvider>
  );
};

export default Project;
